import { render, staticRenderFns } from "./SocialMeetingPostMakePage.vue?vue&type=template&id=3454e4d2&scoped=true"
import script from "./SocialMeetingPostMakePage.vue?vue&type=script&lang=js"
export * from "./SocialMeetingPostMakePage.vue?vue&type=script&lang=js"
import style0 from "./SocialMeetingPostMakePage.vue?vue&type=style&index=0&id=3454e4d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3454e4d2",
  null
  
)

export default component.exports